<template>
	<v-tooltip top color="black">
		<template #activator="{ on, attrs }">
			<v-btn
				icon
				v-bind="attrs"
				@click.stop.prevent="trataAcaoDeBotaoDesabilitado(() => $emit('click'))"
				v-on="on"
			>
				<v-icon :color="cor">
					{{ icone }}
				</v-icon>
			</v-btn>
		</template>
		<span>{{ texto }}</span>
	</v-tooltip>
</template>

<script>
import trataAcaoDeBotaoDesabilitado from '@/views/mixins/trataAcaoDeBotaoDesabilitado'

export default {
	name: 'botao-tooltip-datatable',
	mixins: [trataAcaoDeBotaoDesabilitado],
	props: {
		cor: {
			type: String,
			default: 'primary',
		},
		icone: {
			type: String,
			default: '',
		},
		texto: {
			type: String,
			default: '',
		},
	},
}
</script>
<style scoped></style>
